// extracted by mini-css-extract-plugin
export default {"intro":"styles_intro__e58+o","footer":"styles_footer__pJ4t+"};